var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.20002C10.6745 7.20002 9.60001 6.12551 9.60001 4.80002C9.60001 3.47454 10.6745 2.40002 12 2.40002C13.3255 2.40002 14.4 3.47454 14.4 4.80002C14.4 6.12551 13.3255 7.20002 12 7.20002Z",
    fill: "#4FC0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4C10.6745 14.4 9.60001 13.3255 9.60001 12C9.60001 10.6745 10.6745 9.60002 12 9.60002C13.3255 9.60002 14.4 10.6745 14.4 12C14.4 13.3255 13.3255 14.4 12 14.4Z",
    fill: "#4FC0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6C10.6745 21.6 9.60001 20.5255 9.60001 19.2C9.60001 17.8745 10.6745 16.8 12 16.8C13.3255 16.8 14.4 17.8745 14.4 19.2C14.4 20.5255 13.3255 21.6 12 21.6Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.1d9f4b2276ef20af8c7b842d9948c3b3.svg";
export { ForwardRef as ReactComponent };